import {Injectable} from '@angular/core';
import {AuthenticationService} from "@tva/ng-migration/core";
import {Observable} from "rxjs";

@Injectable()
export class QuickLinksService {

    constructor(private authentication: AuthenticationService) {
    }

    ssoLogin(): Observable<string> {
        return this.authentication.refreshKeycode();
    }
}
